import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "px-5 pt-6 pb-4 bg-white" };
const _hoisted_2 = {
    key: 0,
    class: "flex items-center justify-center py-16"
};
const _hoisted_3 = {
    key: 1,
    class: "max-w-270 mx-auto"
};
const _hoisted_4 = { class: "flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4 mb-6 sm:mb-8" };
const _hoisted_5 = { class: "flex-1" };
const _hoisted_6 = { class: "text-2xl sm:text-3xl font-bold text-gray-900 mb-2" };
const _hoisted_7 = { class: "text-sm sm:text-base text-gray-600" };
const _hoisted_8 = { class: "flex items-center justify-between p-4 sm:p-6" };
const _hoisted_9 = { class: "flex items-center flex-1 min-w-0" };
const _hoisted_10 = { class: "flex items-center justify-center w-12 h-12 rounded-lg border border-[color:var(--colors-border-base-soft)] bg-white mr-3 shrink-0" };
const _hoisted_11 = { class: "min-w-0" };
const _hoisted_12 = { class: "text-base sm:text-lg font-semibold text-gray-900" };
const _hoisted_13 = { class: "text-xs sm:text-sm text-gray-500 mt-0.5" };
const _hoisted_14 = { class: "flex items-center gap-4 sm:gap-6 ml-6 shrink-0" };
const _hoisted_15 = ["for"];
const _hoisted_16 = { class: "sr-only" };
const _hoisted_17 = { class: "text-xs font-medium text-gray-500 whitespace-nowrap" };
const _hoisted_18 = ["for"];
const _hoisted_19 = { class: "sr-only" };
const _hoisted_20 = { class: "text-xs font-medium text-gray-500 whitespace-nowrap" };
const _hoisted_21 = { class: "flex items-center justify-between" };
const _hoisted_22 = { class: "flex-1 min-w-0" };
const _hoisted_23 = { class: "font-medium text-gray-900 text-sm sm:text-base" };
const _hoisted_24 = { class: "text-xs sm:text-sm text-gray-500 mt-1" };
const _hoisted_25 = { class: "flex items-center gap-4 sm:gap-6 ml-6 shrink-0" };
const _hoisted_26 = ["for"];
const _hoisted_27 = { class: "sr-only" };
const _hoisted_28 = { class: "text-xs font-medium text-gray-500 whitespace-nowrap" };
const _hoisted_29 = ["for"];
const _hoisted_30 = { class: "sr-only" };
const _hoisted_31 = { class: "text-xs font-medium text-gray-500 whitespace-nowrap" };
import { ref, reactive, onMounted, nextTick } from "vue";
import { useI18n } from "vue-i18n";
import { Checkbox, FormSaveButton, UnsavedChangesModal, useToast } from "@eudonet/opal";
import { NotificationPreferencesService } from "../../infrastructure/adapters/NotificationPreferencesService";
import { useDirtyState } from "@/shared/composables/forms/useDirtyState";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Notifications',
    setup(__props) {
        const { t } = useI18n();
        const { showToast } = useToast();
        const notificationService = new NotificationPreferencesService();
        const isSaving = ref(false);
        const isLoading = ref(true);
        const notifications = reactive({
            newProgramInterest: { inApp: false, email: false },
            applicationDeadlineApproaching: { inApp: false, email: false },
            newMessageReceived: { inApp: false, email: false },
            mentionedInComment: { inApp: false, email: false },
            unreadMessagesReminder: { inApp: false, email: false },
            admissionDecisionPending: { inApp: false, email: false },
            offerAcceptanceReceived: { inApp: false, email: false },
            enrollmentDeadlineApproaching: { inApp: false, email: false },
        });
        const sections = [
            {
                key: "conversations",
                icon: "ri-message-2-line",
                items: [
                    { dataKey: "mentionedInComment", i18nKey: "conversations.mentioned" },
                    { dataKey: "newMessageReceived", i18nKey: "conversations.newMessage" },
                    { dataKey: "unreadMessagesReminder", i18nKey: "conversations.unreadReminder" },
                ],
            },
            {
                key: "programs",
                icon: "ri-list-check",
                items: [
                    { dataKey: "newProgramInterest", i18nKey: "programs.newInterest" },
                    { dataKey: "applicationDeadlineApproaching", i18nKey: "programs.deadlineApproaching" },
                ],
            },
            {
                key: "admissions",
                icon: "ri-list-check",
                items: [
                    { dataKey: "admissionDecisionPending", i18nKey: "admissions.decisionPending" },
                    { dataKey: "offerAcceptanceReceived", i18nKey: "admissions.offerAccepted" },
                    { dataKey: "enrollmentDeadlineApproaching", i18nKey: "admissions.enrollmentDeadline" },
                ],
            },
        ];
        const sectionState = (section, field) => {
            const values = section.items.map((item) => notifications[item.dataKey][field]);
            const checkedCount = values.filter(Boolean).length;
            if (checkedCount === 0)
                return { checked: false, indeterminate: false };
            if (checkedCount === values.length)
                return { checked: true, indeterminate: false };
            return { checked: false, indeterminate: true };
        };
        const toggleSection = (section, field) => {
            const state = sectionState(section, field);
            const newValue = state.indeterminate || !state.checked;
            section.items.forEach((item) => {
                notifications[item.dataKey][field] = newValue;
            });
        };
        // Unsaved-changes modal state
        const showUnsavedChangesModal = ref(false);
        const pendingRouteCallbacks = {
            proceed: null,
            cancel: null,
        };
        // Dirty state tracking — also handles original data backup, reset, and beforeunload
        const { isDirty, markAsSaved, resetToOriginal } = useDirtyState({
            data: notifications,
            onNavigationBlocked: (proceed, cancel) => {
                showUnsavedChangesModal.value = true;
                pendingRouteCallbacks.proceed = proceed;
                pendingRouteCallbacks.cancel = cancel;
            },
            enableBeforeUnload: true,
        });
        const handleStay = () => {
            showUnsavedChangesModal.value = false;
            if (pendingRouteCallbacks.cancel) {
                pendingRouteCallbacks.cancel();
                pendingRouteCallbacks.proceed = null;
                pendingRouteCallbacks.cancel = null;
            }
        };
        const handleLeave = () => {
            showUnsavedChangesModal.value = false;
            resetToOriginal();
            if (pendingRouteCallbacks.proceed) {
                pendingRouteCallbacks.proceed();
                pendingRouteCallbacks.proceed = null;
                pendingRouteCallbacks.cancel = null;
            }
        };
        const saveChanges = async () => {
            isSaving.value = true;
            try {
                await notificationService.updateNotificationPreferences({ ...notifications });
                await nextTick();
                markAsSaved();
                showToast({
                    message: t("form.saveSuccess"),
                    ariaClose: t("form.dismissToast"),
                    status: "success",
                    duration: 5000,
                });
            }
            catch {
                showToast({
                    message: t("form.saveError"),
                    ariaClose: t("form.dismissToast"),
                    status: "error",
                });
            }
            finally {
                isSaving.value = false;
            }
        };
        onMounted(async () => {
            try {
                const data = await notificationService.getNotificationPreferences();
                if (data) {
                    Object.assign(notifications, data);
                }
            }
            catch {
                showToast({
                    message: t("notifications.loadError"),
                    ariaClose: t("form.dismissToast"),
                    status: "error",
                });
            }
            finally {
                await nextTick();
                markAsSaved();
                isLoading.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" }, null, -1 /* CACHED */)
                        ]))]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t("notifications.title")), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("notifications.subtitle")), 1 /* TEXT */)
                            ]),
                            _createVNode(_unref(FormSaveButton), {
                                enabled: _unref(isDirty),
                                saving: isSaving.value,
                                "save-label": _ctx.$t('form.saveChanges'),
                                "saving-label": _ctx.$t('form.saving'),
                                "disabled-hint": _ctx.$t('form.saveDisabledHint'),
                                onSave: saveChanges
                            }, null, 8 /* PROPS */, ["enabled", "saving", "save-label", "saving-label", "disabled-hint"])
                        ]),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section) => {
                            return _createElementVNode("div", {
                                key: section.key,
                                class: "border border-[color:var(--colors-border-base-soft)] rounded-lg mb-4 sm:mb-6"
                            }, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("i", {
                                                class: _normalizeClass([section.icon, 'text-xl text-gray-700'])
                                            }, null, 2 /* CLASS */)
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t(`notifications.${section.key}.title`)), 1 /* TEXT */),
                                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t(`notifications.${section.key}.description`)), 1 /* TEXT */)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("label", {
                                            for: `notif-${section.key}-all-inApp`,
                                            class: "flex items-center justify-start gap-2 w-36 sm:w-44 pl-4 cursor-pointer"
                                        }, [
                                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t(`notifications.${section.key}.title`)) + " — ", 1 /* TEXT */),
                                            _createVNode(_unref(Checkbox), {
                                                id: `notif-${section.key}-all-inApp`,
                                                class: "!w-auto shrink-0",
                                                "model-value": sectionState(section, 'inApp').checked,
                                                indeterminate: sectionState(section, 'inApp').indeterminate,
                                                "onUpdate:modelValue": ($event) => (toggleSection(section, 'inApp'))
                                            }, null, 8 /* PROPS */, ["id", "model-value", "indeterminate", "onUpdate:modelValue"]),
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("notifications.allInApp")), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_15),
                                        _createElementVNode("label", {
                                            for: `notif-${section.key}-all-email`,
                                            class: "flex items-center justify-start gap-2 w-36 sm:w-44 pl-4 cursor-pointer"
                                        }, [
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(`notifications.${section.key}.title`)) + " — ", 1 /* TEXT */),
                                            _createVNode(_unref(Checkbox), {
                                                id: `notif-${section.key}-all-email`,
                                                class: "!w-auto shrink-0",
                                                "model-value": sectionState(section, 'email').checked,
                                                indeterminate: sectionState(section, 'email').indeterminate,
                                                "onUpdate:modelValue": ($event) => (toggleSection(section, 'email'))
                                            }, null, 8 /* PROPS */, ["id", "model-value", "indeterminate", "onUpdate:modelValue"]),
                                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("notifications.allEmails")), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_18)
                                    ])
                                ]),
                                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "px-4 sm:px-6" }, [
                                    _createElementVNode("div", { class: "border-b border-[color:var(--colors-border-base-soft)]" })
                                ], -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: item.dataKey,
                                        class: _normalizeClass(["p-4 sm:p-6", {
                                                'border-b border-[color:var(--colors-border-base-soft)]': index < section.items.length - 1,
                                            }])
                                    }, [
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.$t(`notifications.${item.i18nKey}.title`)), 1 /* TEXT */),
                                                _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t(`notifications.${item.i18nKey}.description`)), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("div", _hoisted_25, [
                                                _createElementVNode("label", {
                                                    for: `notif-${item.dataKey}-inApp`,
                                                    class: "flex items-center justify-start gap-2 w-36 sm:w-44 pl-4 cursor-pointer"
                                                }, [
                                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t(`notifications.${item.i18nKey}.title`)) + " — ", 1 /* TEXT */),
                                                    _createVNode(_unref(Checkbox), {
                                                        id: `notif-${item.dataKey}-inApp`,
                                                        modelValue: notifications[item.dataKey].inApp,
                                                        "onUpdate:modelValue": ($event) => ((notifications[item.dataKey].inApp) = $event),
                                                        class: "!w-auto shrink-0"
                                                    }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue"]),
                                                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("notifications.inApp")), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_26),
                                                _createElementVNode("label", {
                                                    for: `notif-${item.dataKey}-email`,
                                                    class: "flex items-center justify-start gap-2 w-36 sm:w-44 pl-4 cursor-pointer"
                                                }, [
                                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t(`notifications.${item.i18nKey}.title`)) + " — ", 1 /* TEXT */),
                                                    _createVNode(_unref(Checkbox), {
                                                        id: `notif-${item.dataKey}-email`,
                                                        modelValue: notifications[item.dataKey].email,
                                                        "onUpdate:modelValue": ($event) => ((notifications[item.dataKey].email) = $event),
                                                        class: "!w-auto shrink-0"
                                                    }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue"]),
                                                    _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("notifications.emails")), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_29)
                                            ])
                                        ])
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]);
                        }), 64 /* STABLE_FRAGMENT */))
                    ])),
                _createVNode(_unref(UnsavedChangesModal), {
                    modelValue: showUnsavedChangesModal.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((showUnsavedChangesModal).value = $event)),
                    title: _ctx.$t('unsavedChanges.title'),
                    message: _ctx.$t('unsavedChanges.message'),
                    "stay-label": _ctx.$t('unsavedChanges.stay'),
                    "leave-label": _ctx.$t('unsavedChanges.leave'),
                    onStay: handleStay,
                    onLeave: handleLeave
                }, null, 8 /* PROPS */, ["modelValue", "title", "message", "stay-label", "leave-label"])
            ]));
        };
    }
});
